import _ from 'lodash';
import { publish } from '@jutro/events';
import {
    ADOBE_TOPICS,
    COMMON_TAGGING_PROPERTIES,
    SgProductService,
    SgSessionStorageService
} from 'saga-modules';
import { SG_AA_PAGE_NAME } from '../AdobeAnalyticsConstants';

let productMetadataTypes;
let translator;

const getTypelistValue = (typelist, value) => {
    const typelistCode = value.code || value;
    const typelistValue = typelistCode && !_.isObject(typelistCode)
        ? productMetadataTypes.getTypelist(typelist).getCode(typelistCode).name : undefined;
    return typelistValue ? translator({ id: typelistValue, defaultMessage: typelistValue }) : undefined;
};

function constructPageModel(page) {
    return `${SG_AA_PAGE_NAME.INSURANCE}|${SG_AA_PAGE_NAME.INSURANCE_TYPE}|${SG_AA_PAGE_NAME.GET_QUOTE}|${page}`;
}

function addTrackingScidToURL(name, isBestPrice) {
    const productType = SgProductService.isHome() ? 'home' : 'car';
    const trackingUrl = `agg|ser|${productType}|na|`;
    const bestPriceUrlText = isBestPrice === true ? 'bestprice' : 'nonbestprice';
    const scid = trackingUrl.concat(name.replace(/ /g, '').toLowerCase(), '|', bestPriceUrlText);
    if ((window.location.hash.indexOf('scid') === -1)) {
        const state = JSON.parse(SgSessionStorageService.getItem(SgSessionStorageService.KEY.AGG_QUOTE_STATE));
        const url = `${window.location.hash}?scid=${encodeURIComponent(scid)}`;
        window.history.replaceState(state, '', url);
    }
    publish(ADOBE_TOPICS.ADOBE_EVENT, {
        adobeID: COMMON_TAGGING_PROPERTIES.scid,
        value: scid
    });
}

/**
 * @param {String} preferences CommunicationPreference name
 * @returns {String} contactTypeString
 */
function getContactTypeString(preferences) {
    let contactTypeString = ''; // init
    // build concatenated string for preference selection
    if (preferences.hasEmailSelected) {
        contactTypeString += 'email|';
    }
    if (preferences.hasPhoneSelected) {
        contactTypeString += 'phone|';
    }
    if (preferences.hasLetterSelected) {
        contactTypeString += 'post|';
    }
    // Remove trailing pipe
    contactTypeString = contactTypeString.slice(0, -1);

    return contactTypeString;
}

/**
 * @param {String} preferences CommunicationPreference name
 * @returns {String} businessAreaString
 */
function getBusinessAreaString(preferences) {
    let businessAreaString = ''; // init
    // build concatenated string for area selection
    if (preferences.hasInsuranceSelected) {
        businessAreaString += 'insurance|';
    }
    if (preferences.hasTravelSelected) {
        businessAreaString += 'holidays|';
    }
    if (preferences.hasFinancialSelected) {
        businessAreaString += 'personalfinance|';
    }
    if (preferences.hasMagazineSelected) {
        businessAreaString += 'sagamagazine|';
    }
    // Remove trailing pipe
    businessAreaString = businessAreaString.slice(0, -1);

    return businessAreaString;
}

function wasBusinessAreaPreviouslySelected(area, divisions) {
    if (divisions.length === 0) {
        return false;
    }
    return divisions.indexOf(area) > -1;
}

function getScidUrl(queryString) {
    const { scid } = queryString;
    if (scid) {
        SgSessionStorageService.setItem(SgSessionStorageService.KEY.SCID_VALUE, decodeURIComponent(scid));
        return decodeURIComponent(scid);
    }
    return undefined;
}

const getCurrentPageName = () => {
    const hrefArr = window.location.href.split('/');
    return hrefArr[hrefArr.length - 1];
};

function getLoggedInStatus() {
    // check for existance of ctic cookie
    return document.cookie.indexOf('; ctic=') > -1;
}

export default {
    init(viewModelService, translatorContext) {
        productMetadataTypes = viewModelService.productMetadata.get('pc').types;
        translator = translatorContext;
    },
    constructPageModel,
    getTypelistValue,
    getScidUrl,
    addTrackingScidToURL,
    getContactTypeString,
    getBusinessAreaString,
    wasBusinessAreaPreviouslySelected,
    getCurrentPageName,
    getLoggedInStatus
};
